export const API_CONFIG = {
  BASE_URL: 'https://api-tdfa.ashwanthbk.com',
  ENDPOINTS: {
    AUTH: {
      LOGIN_SEND_CODE: '/api/auth/login/code/send/',
      LOGIN_VERIFY_CODE: '/api/auth/login/code/verify/',
      REFRESH_TOKEN: '/api/auth/token/refresh/',
      VERIFY_TOKEN: '/api/auth/token/verify/',
    },
    USER: {
      ME: '/api/auth/users/me/',
    },
    MEMBERS: {
      LIST: '/api/auth/users/',
      DETAIL: (id: string) => `/api/auth/users/${id}/`,
      CREATE: '/api/auth/users/',
      UPDATE: (id: string) => `/api/auth/users/${id}/`,
      DELETE: '/api/auth/users/delete/',
      ROLES: '/api/auth/roles/',
    },
    DEBTORS: {
      LIST: '/api/debtors/',
      DETAIL: (id: string) => `/api/debtors/${id}/`,
      CREATE: '/api/debtors/',
      CHECK_AADHAAR: '/api/debtors/get_by_aadhaar/',
      ADD_ENTRY: (id: string) => `/api/debtors/${id}/add_entry/`,
      DELETE: '/api/debtors/delete/',
      RESTORE: '/api/debtors/restore/',
    },
    ACCOUNTS: {
      ENTRIES: '/api/entries/',
      DETAIL: (id: string) => `/api/entries/${id}/`,
      APPROVE: (id: string) => `/api/entries/${id}/approve/`,
      SUMMARY: '/api/entries/summary/',
      MONTHLY_STATS: '/api/entries/monthly_stats/',
      FINANCIAL_YEAR_STATS: '/api/entries/financial_year_stats/',
    },
  },
} as const;

// Types for API endpoints to enable type safety when passing URLs
export type ApiEndpoint =
  | typeof API_CONFIG.ENDPOINTS.AUTH.LOGIN_SEND_CODE
  | typeof API_CONFIG.ENDPOINTS.AUTH.LOGIN_VERIFY_CODE
  | typeof API_CONFIG.ENDPOINTS.AUTH.REFRESH_TOKEN
  | typeof API_CONFIG.ENDPOINTS.AUTH.VERIFY_TOKEN
  | typeof API_CONFIG.ENDPOINTS.MEMBERS.LIST
  | typeof API_CONFIG.ENDPOINTS.ACCOUNTS.ENTRIES
  | typeof API_CONFIG.ENDPOINTS.ACCOUNTS.SUMMARY
  | typeof API_CONFIG.ENDPOINTS.ACCOUNTS.MONTHLY_STATS
  | typeof API_CONFIG.ENDPOINTS.ACCOUNTS.FINANCIAL_YEAR_STATS
  | string; // For dynamic endpoints created with functions
